import React, { createContext, useState, ReactNode } from 'react';
import { ConfigType } from "src/types/index"

interface AppContextType {
  token: string;
  refreshToken: string;
  setRefreshToken: (token: string) => void;
  organizationId: string;
  setToken: (token: string) => void;
  setOrganizationId: (id: string) => void;
  clusterId: string;
  setClusterId: (id: string) => void;
  organizationInfo: ConfigType;
  setOrganizationInfo: (data: ConfigType) => void;
  email: string;
  setEmail: (email: string) => void;
  organizations: any[];
  setOrganizations: (data: any[]) => void;
}

export const AppContext = createContext<AppContextType>({
  clusterId: '',
  setClusterId: () => {},
  token: '',
  refreshToken: '',
  setRefreshToken: () => {},
  organizationId: '',
  setToken: () => {}, 
  setOrganizationId: () => {},
  organizationInfo: {} as ConfigType,
  setOrganizationInfo: () => { },
  email: '',
  setEmail: () => {},
  setOrganizations: () => {},
  organizations: []
});

interface AppProviderProps {
  children: ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  const [token, setToken] = useState<string>(() => localStorage.getItem('token') || '');
  const [email, setEmail] = useState<string>(
    () => localStorage.getItem("email") || ""
  );
  const [organizations, setOrganizations] = useState<any[]>([]);
  const [organizationId, setOrganizationId] = useState<string>(
    () => localStorage.getItem("organizationId") || ""
  );
  const [refreshToken, setRefreshToken] = useState<string>(() => localStorage.getItem('refreshToken') || '');
  const [clusterId, setClusterId] = useState<string>(() => localStorage.getItem('clusterId') || '');
  const [organizationInfo, setOrganizationInfo] = useState<ConfigType>({} as ConfigType);


  const handleSetToken = (newToken: string) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  };

    const handleSetEmail = (newEmail: string) => {
      localStorage.setItem("email", newEmail);
      setEmail(newEmail);
    };

  const handleSetOrganizationId = (newId: string) => {
    localStorage.setItem('organizationId', newId);
    setOrganizationId(newId);
  };

  const handleSetRefreshToken = (newToken: string) => {
    localStorage.setItem('refreshToken', newToken);
    setRefreshToken(newToken);
  };

  const handleSetClusterId = (id: string) => {
    localStorage.setItem('clusterId', id);
    setClusterId(id);
  };
  const value = {
    token,
    refreshToken,
    setRefreshToken: handleSetRefreshToken,
    organizationId,
    setToken: handleSetToken,
    setOrganizationId: handleSetOrganizationId,
    clusterId,
    setClusterId: handleSetClusterId,
    organizationInfo,
    setOrganizationInfo,
    email,
    setEmail: handleSetEmail,
    setOrganizations,
    organizations,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
